export enum ENatsContextActions {
  STORE_SUBSCRIPTION = 'STORE_SUBSCRIPTION',
  SET_TOPIC = 'SET_TOPIC',
  REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION',
  SAVE_MESSAGE = 'SAVE_MESSAGE',
  SET_STARTED = 'SET_STARTED',
}
